module.exports = __webpack_public_path__ + "img/numeralia_cedis_5.5cf27242.png";